import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebook,
  faGithub,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import ArrowToTop from '../arrowToTop/ArrowToTop';

const FOOTER_NAV_LINKS = [
  { to: '/prices', key: 'prices' },
  { to: '/design', key: 'design' },
  { to: '/projects', key: 'projects' },
  { to: '/gallery', key: 'gallery' },
  { to: '/contacts', key: 'contacts' },
];

const Footer = ({ openCookieSettings }) => {
  const { t } = useTranslation('common');

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          <nav className="footer__nav" aria-label={t('footer.navLabel')}>
            <ul className="footer__nav-list">
              {FOOTER_NAV_LINKS.map(({ to, key }) => (
                <li key={key}>
                  <Link className="footer__nav-link" to={to}>
                    {t(`nav.${key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <ul className="social">
            <li className="social__item">
              <a href="tel:+358468130887" aria-label="Phone">
                <FontAwesomeIcon icon={faPhoneSquare} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://www.instagram.com/pixelcraft.fi/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://github.com/maikamp-ven"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://www.facebook.com/profile.php?id=61567865667907"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://wa.me/358468130887"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </li>
            <li className="social__item">
              <a href="mailto:info@pixelcraft.fi" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </li>
          </ul>

          <div className="footer__legal">
            <Link className="footer__legal-link" to="/privacy-policy">
              {t('footer.privacyPolicy')}
            </Link>

            <Link className="footer__legal-link" to="/cookie-policy">
              {t('footer.cookiePolicy')}
            </Link>

            <Link className="footer__legal-link" to="/terms-of-use">
              {t('footer.termsOfUse')}
            </Link>

            <button
              type="button"
              className="footer__legal-link"
              onClick={openCookieSettings}
            >
              {t('footer.cookieSettings')}
            </button>
          </div>

          <div className="footer__bottom">
            <p className="footer__copyright">
              {t('footer.rightsReserved')}
            </p>
          </div>
        </div>
      </div>

      <ArrowToTop />
    </footer>
  );
};

export default Footer;